import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";
import { useLocation, useParams } from "react-router-dom";
import { uploadCategoryPhoto } from "../../../services/categories";

function UploadPhoto({ handleClose }) {
  const [image, setImage] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const params = useParams();
  const location = useLocation();
  const queryClient = useQueryClient();

  const categoryId = location.state?.categoryId || params.id;
  const submitPhotoMutation = useMutation({
    mutationFn: uploadCategoryPhoto,
    onError(error) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
    onSuccess() {
      enqueueSnackbar("Add Photo success!", { variant: "success" });
      queryClient.invalidateQueries("category-detail");
      handleClose && handleClose();
    },
  });
  const handleUploadImage = (event) => {
    const file = event.target.files[0];
    setUploadImage(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteImage = () => {
    setImage(null);
    setUploadImage(null);
  };

  const handleSubmitPhoto = () => {
    submitPhotoMutation.mutate({
      data: uploadImage,
      categoryId: categoryId,
    });
  };
  return (
    <div>
      <h3 className="text-center">Upload Photo</h3>
      <div
        className="card d-flex"
        style={{ minWidth: "18rem", minHeight: "4rem" }}
      >
        <div className="card-body d-flex flex-nowrap">
          {image && (
            <div
              className="card"
              style={{
                position: "relative",
                padding: "10px",
                width: "fit-content",
                height: "fit-content",
              }}
            >
              <i
                className="bi bi-x-circle"
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: "-2px",
                  left: "2px",
                }}
                onClick={() => handleDeleteImage()}
              ></i>
              <img
                src={image}
                alt="..."
                style={{ width: "100px" }}
                className="img-thumbnail"
              />
            </div>
          )}
        </div>
      </div>
      <input
        type="file"
        accept=".webp"
        onChange={(event) => handleUploadImage(event)}
      />
      <div className="d-flex" style={{ padding: "20px", gap: "20px" }}>
        <button className="btn btn-primary" onClick={handleSubmitPhoto}>
          {submitPhotoMutation.isLoading && (
            <span>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              &nbsp;
            </span>
          )}
          Submit
        </button>
        {/* <button className=" btn btn-danger">Cancel</button> */}
      </div>
    </div>
  );
}

export default UploadPhoto;
